import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';
import { autoUpdateSessionStorage, reactivityFix } from '@/apps/order/helper';

import { useRouterStore } from '@/apps/order/stores';

import CustomerDataInterface from '@/apps/order/interfaces/CustomerDataInterface';

const useOrdersCreateCustomerStore = defineStore('ordersCreateCustomer', () => {
  const routerStore = useRouterStore();
  const { meta } = storeToRefs(routerStore);

  const existingCustomerData = ref<CustomerDataInterface | undefined>();
  reactivityFix(existingCustomerData);
  autoUpdateSessionStorage(`${meta.value.ctx}.existingCustomerData`, () => existingCustomerData.value, 1000);

  return {
    existingCustomerData,
  };
});

export default useOrdersCreateCustomerStore;
